import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { UserSimple } from '@app/user';
import { Course, Mission } from '@app/core/model/library.model';
import { Affected } from '../models';

@Injectable()
export class AffectedService {
    private _affected$ = new BehaviorSubject<Affected>({
        loaded: null,
        users: {
            items: null,
            appending: null,
            lazyload: {
                offset: {
                    prefixPosition: 0,
                    suffixPosition: 0,
                },
                totalItems: 0,
                limit: 50,
            },
        },
        content: {
            course: null,
            missions: null,
        },
    });

    affected$ = this._affected$.asObservable();

    get affected() {
        return this._affected$.value;
    }

    get appending() {
        return this.affected.users.appending;
    }

    get hasAllUsersLoaded() {
        return this.affected.users.items !== null && this.affected.users.items.length === this.affected.users.lazyload.totalItems;
    }

    setAffectedLoaded(loaded: boolean) {
        this._affected$.next({
            ...this.affected,
            loaded,
        });
    }

    setAffectedUsers(items: UserSimple[], pagination: { total: number; suffixPosition: number }) {
        this._affected$.next({
            ...this.affected,
            users: {
                ...this.affected.users,
                lazyload: {
                    ...this.affected.users.lazyload,
                    totalItems: pagination.total,
                    offset: {
                        ...this.affected.users.lazyload.offset,
                        suffixPosition: pagination.suffixPosition + this.affected.users.lazyload.offset.suffixPosition,
                    },
                },
                items,
            },
        });
    }

    setAffectedUsersAppending(appending: boolean) {
        this._affected$.next({
            ...this.affected,
            users: {
                ...this.affected.users,
                appending,
            },
        });
    }

    setAffectedContent(content: { course: Course; missions: Mission[] }) {
        this._affected$.next({
            ...this.affected,
            content,
        });
    }
}
